import { apiClient } from './client';
import type {
  Bebauungsplan,
  BebauungsplanCreate,
  BebauungsplanListItem,
  BebauungsplanUpdate,
  ListingBebauungsplanResponse,
} from '../types/bebauungsplan';
import type { PaginatedResponse } from '../types/api';

export interface BebauungsplaeneQueryParams {
  page?: number;
  per_page?: number;
  gebietsart?: string;
  search_text?: string;
  include_hidden?: boolean;
  include_geometry?: boolean;
}

export type BebauungsplanListResponse = PaginatedResponse<BebauungsplanListItem>;

export const bebauungsplaeneApi = {
  list: async (params: BebauungsplaeneQueryParams = {}): Promise<BebauungsplanListResponse> => {
    const { data } = await apiClient.get('/bebauungsplaene/', { params });
    return data;
  },
  get: async (id: number): Promise<Bebauungsplan> => {
    const { data } = await apiClient.get(`/bebauungsplaene/${id}`);
    return data;
  },
  create: async (body: BebauungsplanCreate = {}): Promise<Bebauungsplan> => {
    const { data } = await apiClient.post('/bebauungsplaene/', body);
    return data;
  },
  update: async (id: number, body: BebauungsplanUpdate): Promise<Bebauungsplan> => {
    const { data } = await apiClient.patch(`/bebauungsplaene/${id}`, body);
    return data;
  },
  remove: async (id: number, reason?: string): Promise<{ status: string; id: number }> => {
    const { data } = await apiClient.delete(`/bebauungsplaene/${id}`, {
      data: reason ? { reason } : undefined,
    });
    return data;
  },
  matchAtCoords: async (lat: number, lon: number): Promise<ListingBebauungsplanResponse> => {
    const { data } = await apiClient.get('/bebauungsplaene/match', { params: { lat, lon } });
    return data;
  },
};
